<template>
  <v-container grid-list-xs fluid>
    <!-- DATA TABLE -->
    <v-card class="layout row wrap shadow pa-3 mt-3">
      <div class="flex-row justify-space-between align-center grey lighten-4">
        <strong class="title_label pl-2" slot="activator">
          <span>{{ $t("referral_report") }}</span>
        </strong>
        <v-spacer />
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              flat
              v-on="on"
              color="grey darken-2"
              class="ma-0 mr-2 pa-0"
              @click="printTable(false)"
            >
              <v-icon>print</v-icon>
            </v-btn>
          </template>
          <span>Print Table</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              flat
              v-on="on"
              color="grey darken-2"
              class="ma-0 mr-2 pa-0"
              @click="printTable(true)"
            >
              <v-icon>file_download</v-icon>
            </v-btn>
          </template>
          <span>Excel Export</span>
        </v-tooltip>
      </div>

      <v-data-table
        ref="tbl"
        :items="items"
        class="flex xs12"
        :headers="headers"
        :loading="loading"
        :rows-per-page-items="per_page"
      >
        <template v-slot:items="{ item, index }">
          <tr>
            <td class="font-weight-bold">{{ prettySection(item.section) }}</td>
            <td class="font-weight-bold">
              <router-link
                :to="`/CSOs/${cso.id}`"
                v-for="cso in item.csos"
                :key="`${index}_${cso.id}`"
              >
                {{ cso.name }},
              </router-link>
            </td>
            <td class="font-weight-bold">{{ item.csos.length }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
let currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 7);

export default {
  name: "reports-view",
  data: () => ({
    items: [],
    loading: false,
    programAreas: [],
    end_date: new Date().toISOString().substring(0, 10),
    start_date: currentDate.toISOString().substring(0, 10)
  }),
  filters: {
    pretty: val => (val == 1 ? "Q" : "NQ")
  },
  computed: {
    headers: vm => [
      {
        text: "Section",
        value: "section",
        width: "350px",
        computed: item => vm.prettySection(item.section)
      },
      {
        text: `CSOs Name`,
        value: "csos",
        computed: item => item.csos.map(x => x.name).join(", ")
      },
      {
        text: `Total`,
        value: "csos",
        width: "120px",
        computed: item => item.csos.length
      }
    ]
  },

  methods: {
    getData() {
      this.loading = true;
      this.axios
        .get(`reports?referral=true`)
        .then(res => {
          this.items = res.data.map(item => {
            let names = item.names.split(", ");
            let ids = item.ids.split(", ");
            let csos = names.map((x, i) => ({ name: x, id: ids[i] }));
            return { section: item.section, csos };
          });
          this.loading = false;
        })
        .catch(vm => (vm.loading = false));
    },

    printTable(excel) {
      let items = [...this.items];
      let data = {
        items: items,
        headers: this.headers,
        title: this.$t("referral_report")
      };

      if (excel) return this.xl_tables(data, "Referral - Report");
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    }
  },
  created() {
    this.getData();
  }
};
</script>
